// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { Container, Dimmer, Icon, Message } from "semantic-ui-react";
import Sentry from "../../services/sentry";
import * as i18n from "../../config/i18n";
import "./ApplicationError.less";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("error");
// eslint-disable-next-line max-len
export class ApplicationError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      dependencies
    } = this.props;
    const {
      error
    } = this.state;
    if (error !== null && prevState.error !== null && !_.isEqual(prevProps.dependencies, dependencies)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        error: null,
        hasError: false
      });
    }
  }
  componentDidCatch(error) {
    this.setState({
      error
    });
    Sentry?.captureException(error);
  }
  render() {
    const {
      children,
      scope
    } = this.props;
    const {
      hasError,
      error
    } = this.state;
    if (hasError) {
      if (scope === "content") {
        return /*#__PURE__*/_jsx(Dimmer.Dimmable, {
          className: className,
          dimmed: true,
          blurring: true,
          "data-sentry-element": "unknown",
          "data-sentry-component": "ApplicationError",
          "data-sentry-source-file": "ApplicationError.tsx",
          children: /*#__PURE__*/_jsx(Dimmer, {
            active: true,
            inverted: true,
            "data-sentry-element": "Dimmer",
            "data-sentry-source-file": "ApplicationError.tsx",
            children: /*#__PURE__*/_jsx(Container, {
              "data-sentry-element": "Container",
              "data-sentry-source-file": "ApplicationError.tsx",
              children: /*#__PURE__*/_jsxs(Message, {
                info: true,
                icon: true,
                "data-sentry-element": "Message",
                "data-sentry-source-file": "ApplicationError.tsx",
                children: [/*#__PURE__*/_jsx(Icon, {
                  name: "searchengin",
                  "data-sentry-element": "Icon",
                  "data-sentry-source-file": "ApplicationError.tsx"
                }), /*#__PURE__*/_jsxs(Message.Content, {
                  "data-sentry-element": "unknown",
                  "data-sentry-source-file": "ApplicationError.tsx",
                  children: [/*#__PURE__*/_jsx(Message.Header, {
                    "data-sentry-element": "unknown",
                    "data-sentry-source-file": "ApplicationError.tsx",
                    children: i18n.errorHeader
                  }), /*#__PURE__*/_jsx("p", {
                    children: /*#__PURE__*/_jsx("span", {
                      children: i18n.errorMessage
                    })
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
                    children: /*#__PURE__*/_jsx("i", {
                      children: /*#__PURE__*/_jsx("span", {
                        children: error?.message
                      })
                    })
                  })]
                })]
              })
            })
          })
        });
      }
      return null;
    }
    return children;
  }
}